module.exports = __webpack_public_path__ + "img/워셰이퍼.be1e87b9.png";